/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ pÃ gina',
  jump_to: 'Anar a',
  jump_to_confirm: 'Confirmar',
  page: '',

  // Pagination.jsx
  prev_page: 'PÃ gina prÃ¨via',
  next_page: 'PÃ gina segÃ¼ent',
  prev_5: '5 pÃ gines prÃ¨vies',
  next_5: '5 pÃ gines segÃ¼ents',
  prev_3: '3 pÃ gines prÃ¨vies',
  next_3: '3 pÃ gines segÃ¼ents'
};
